import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faSpinner } from '@fortawesome/free-solid-svg-icons';
import '../IssuesPage/IssuesPage.css';
import { Attachment } from '../../../interfaces/ticket/Comment';

interface AttachmentItemProps {
    attachment: Attachment;
}

const AttachmentItem: React.FC<AttachmentItemProps> = ({ attachment }) => {
    const [displayUrl, setDisplayUrl] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true); // Start loading
    const [isImage, setIsImage] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true); // Reset loading state for new attachment
        setDisplayUrl(null); // Clear previous URL
        setIsImage(false); // Reset image type

        if (attachment.url) {
            if (attachment.mimeType?.startsWith('image/')) {
                setIsImage(true);
                setDisplayUrl(attachment.url); // Directly use the URL
            } else {
                // For non-image files, we just display the generic icon
                setDisplayUrl(attachment.url); // Still keep the URL for the <a> tag
            }
        }
        setIsLoading(false); // Loading is "done" from our component's perspective, browser handles image load
    }, [attachment.url, attachment.mimeType]);

    const renderContent = () => {
        if (isLoading) {
            return <FontAwesomeIcon icon={faSpinner} spin size="2x" />;
        }

        if (isImage && displayUrl) {
            return <img src={displayUrl} alt={attachment.fileName} className="attachment-image-preview" />;
        }

        // Generic file preview for non-images or if image fails to load (browser will show broken icon)
        return (
            <div className="generic-file-preview">
                <FontAwesomeIcon icon={faFileAlt} size="2x" />
                <span>{attachment.fileName}</span>
            </div>
        );
    };

    return (
        <a href={attachment.url} target="_blank" rel="noopener noreferrer" className="attachment-item">
            {renderContent()}
        </a>
    );
};

export default AttachmentItem;
